import * as PromoMessage from './PromoMessage.css';

export default {
	PromoMessage
};
